<template>
    <div class="icon-wrapper">
        <DSIcon code="default-line/like" size="custom" class="success-icon" />
    </div>
    <h2 class="h2">{{ $i18n.t('step5.title') }}</h2>
    <p>{{ $i18n.t('step5.text1') }}</p>
    <p>{{ $i18n.t('step5.text2') }}</p>
    <p>
        <strong>{{ station.name }}</strong><br />
        <template v-if="station.street">
            {{ station.street }}<br />
        </template>
        <template v-if="station.postcode && station.city">
            {{ station.postcode }} <span class="city">{{ station.city?.toLowerCase() }}</span><br />
        </template>
    </p>
    <div v-if="station.telephone" class="phone">
        {{ $i18n.t('step5.phoneNumber') }}<br />
        <strong>{{ station.telephone }}</strong>
    </div>
</template>
<script setup>
import { useI18n, useNuxtApp } from '#imports';

const { $i18n } = useNuxtApp();

defineProps({
    station: {
        type: Object,
        required: false,
        default: () => ({}),
    },
});

useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            step5: {
                title: 'Kiitos!',
                text1: 'Tilaus on vahvistettu, kun saat vahvistusviestin sähköpostiin.',
                text2: 'Jos teit tilauksesi väärin tiedoin ja se pitää peruuttaa tai tarvitset muuten apua tilauksesi kanssa, niin ole yhteydessä suoraan kyseiseen asemaan.',
                phoneNumber: 'Puhelinnumero',
            },
        },
    },
});
</script>
<style scoped>
.icon-wrapper {
  width: 10rem;
  height: 10rem;
  margin: 0 auto;
  padding: 2.5rem;
  border: 4px solid var(--color-base-black);
  border-radius: 50%;
}

.success-icon {
  font-size: 4.5rem;
}

.city {
  text-transform: capitalize;
}

.phone {
  margin-top: 0.5rem;
}
</style>
